<template>
  <div>
    <base-title title="密码修改" />
    <el-form
      :model="params"
      :rules="rules"
      ref="form"
      class="section"
      label-width="80px"
      style="width: 400px;"
    >
      <el-form-item
        label="旧密码"
        prop="oldpwd"
      >
        <el-input
          v-model="params.oldpwd"
          type="password"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="新密码"
        prop="newpwd"
      >
        <el-input
          v-model="params.newpwd"
          type="password"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="确认密码"
        prop="confirmpwd"
      >
        <el-input
          v-model="params.confirmpwd"
          type="password"
          clearable
        />
      </el-form-item>
      <el-form-item class="text-center">
        <el-button
          type="primary"
          style="width: 80px;"
          @click="submit"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import * as api from 'index/api'
import md5 from 'js-md5'
export default {
  name: 'changePassword',

  data () {
    return {
      params: {
        oldpwd: '',
        newpwd: '',
        confirmpwd: ''
      },
      rules: {
        oldpwd: [
          {
            required: true,
            message: '请输入旧密码',
            trigger: 'submit'
          }
        ],
        newpwd: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入密码'))
              } else {
                if (this.params.confirmpwd !== '') {
                  this.$refs.form.validateField('confirmpwd')
                }
                callback()
              }
            },
            trigger: 'submit'
          }
        ],
        confirmpwd: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.params.newpwd) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            },
            trigger: 'submit'
          }
        ]
      }
    }
  },

  methods: {
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const { oldpwd, newpwd, confirmpwd } = this.params
          api.changePassword({
            oldpwd: oldpwd,
            newpwd: newpwd,
            confirmpwd: confirmpwd
          }).then(message => {
            this.$alert('您的密码已经修改,请使用新密码登录')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
